// 配置信息

import mutations from './mutations'
import actions from './actions/index'
import getters from './getters/index'
import { HOST_BBS } from '../../../const'
import { getXSAppInfo } from '../../../common/wzapp'
import { isArray } from '../../../utils/base'

// 基础配置
// const wxConfig = window._wzConfig_ || {}
const wzWebConfig = window._wzWebConfig_ || {}

let { baseConf } = wzWebConfig
const xsWebData = window._xsWebData_ || {}

let { homeModules } = xsWebData

homeModules = isArray(homeModules) ? homeModules : []

const state = {
  baseConf: baseConf || null,
  _latestAppInfo: getXSAppInfo(), // 最新版App信息
  _expMinutes: 120, // 有效时长 120分钟 (即：最后一次加载成功的时间，未超过120分钟，则不再加载）

  homeModules, // 首页模块配置

  // 底导航
  navTabs: [
    {
      text: '大盘押涨跌',
      name: 'index',
      path: '/',
      icon: 'home'
    },
    {
      text: '我的战绩',
      name: 'myCourses',
      path: '/combat',
      icon: 'bag-o'
    },
    {
      text: '战绩排行榜',
      name: 'myAccount',
      path: '/ranking',
      icon: 'manager-o'
    }
  ],

  // 我的
  myBannerLink: {
    ordinary: {
      image:
        'https://staticcdn-yy-prd.pydp888.com/xs/g/img/vip_architecture.png',
      url: '/doc/agreement/vip'
    },
    teacher: {
      image:
        'https://staticcdn-yy-prd.pydp888.com/xs/g/img/teacher_agreement.png',
      url: '/doc/agreement/teacher'
    }
  },

  // URL配置: 部署需要从smarty吐出
  urlHelp: '/room?roomId=31',
  urlAbout: '/doc/about',
  urlAgreementAccount: '/doc/agreement/account',
  urlShopOrders: `https://${HOST_BBS}/plugin.php?id=wei_shop&mod=myorders`
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
